import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { CourseFormValues } from "src/models/Course.model";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useLevels from "src/hooks/useLevels";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";

type Props = {
  formikProps: FormikProps<CourseFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const CourseForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { levels, isDataLoading } = useLevels();

  const levelsOption =
    levels?.map((level: any) => ({
      value: level._id,
      label: level.levelName,
    })) || [];

  const courseOption = [
    { label: "Main", value: "MAIN" },
    { label: "Other", value: "OTHER" },
  ];

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Course" : "Update Course"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="courseName"
            value={values.courseName}
            required
            onChange={(e) => {
              setFieldValue("courseName", e.target.value);
            }}
            label="Course Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMMultiSelect
            name="levels"
            value={values.levels}
            options={levelsOption}
            isLoading={isDataLoading}
            required
            onChange={(e) => {
              setFieldValue("levels", e);
            }}
            label="Levels"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="courseCode"
            value={values.courseCode}
            required
            onChange={(e) => {
              setFieldValue("courseCode", e.target.value);
            }}
            label="Course Code"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="orderRank"
            value={values.orderRank}
            onChange={(e) => {
              setFieldValue("orderRank", e.target.value);
            }}
            label="Order Rank"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMSelect
            name="type"
            options={courseOption}
            value={values.type}
            required
            onChange={(values) => {
              setFieldValue("type", values);
            }}
            label="Type"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default CourseForm;
